module.exports = __webpack_public_path__ + "static/media/logo-apimo@2x.634a3283.png";